class RedirectionPopup extends HTMLElement {
  constructor() {
    super();
    this.cookieName = "localePopup";
    this.userLocale = "";
  }

  connectedCallback() {
    this.currentStore = this.dataset.storeCountry;
    this.popupConfig = JSON.parse(
      document.querySelector("[data-popup-config]").textContent,
    );
    this.popupContent = this.querySelector("[data-popup-content]");
    this.popupButton = this.querySelector("[data-popup-button]");
    this.popupButtonText = this.querySelector("[data-popup-button-text]");
    this.popupButtonCloseText = this.querySelector("[data-popup-close-text]");
    this.popupClose = this.querySelectorAll("[data-popup-close]");
    this.popupClose.forEach((closeButton) => {
      closeButton.addEventListener("click", () => {
        this.setCookie(this.cookieName, "dismissed", 30);
        this.hide();
      });
    });
    this.init();
  }

  async init() {
    if (this.getCookie(this.cookieName) == "dismissed") return;
    await this.checkRegion();
    if (!this.shouldShowPopup()) return;
    this.updatePopupContent();
    this.open();
  }

  // Check user locale using Shopify's browsing context suggestions API, only update if a country is detected and it's different from the current store's country
  async checkRegion() {
    await fetch("/browsing_context_suggestions.json")
      .then((response) => response.json())
      .then((responseJson) => {
        const detectedCountry = responseJson?.detected_values?.country?.handle;
        if (detectedCountry && detectedCountry !== this.currentStore) {
          this.userLocale = detectedCountry;
        }
      });
  }

  // Only show popup if a user locale is detected and exists in our popup config
  shouldShowPopup() {
    if (
      this.userLocale == undefined ||
      this.userLocale == "" ||
      !(this.userLocale in this.popupConfig)
    ) {
      return false;
    } else {
      return true;
    }
  }

  // Update the popup content and button based on the user's locale
  updatePopupContent() {
    const localeConfig = this.popupConfig[this.userLocale];

    this.popupContent.textContent = localeConfig.content;
    this.popupButtonText.textContent =
      localeConfig.button_label || this.popupButtonText.textContent;
    this.popupButtonCloseText.textContent =
      localeConfig.close_label || this.popupButtonCloseText.textContent;
    this.popupButton.href = localeConfig.button_link;
  }

  // Show the popup
  open() {
    document.body.style.overflow = "hidden";
    this.classList.add("redirection-popup--active");
  }

  // Hide the popup
  hide() {
    document.body.style.overflow = "auto";
    this.classList.remove("redirection-popup--active");
  }

  // Set a cookie to prevent the popup from showing again if dismissed for a specified number of days
  setCookie(cName, cValue, expDays) {
    let date = new Date();
    date.setTime(date.getTime() + expDays * 24 * 60 * 60 * 1000);
    const expires = "expires=" + date.toUTCString();
    document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";
  }

  // Get the value of a specified cookie, return false if the cookie is not found
  getCookie(cookieName) {
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      // Check if the cookie starts with the specified name
      if (cookie.startsWith(`${cookieName}=`)) {
        // Get the cookie value by extracting everything after the equals sign
        const value = cookie.substring(cookieName.length + 1);
        return decodeURIComponent(value);
      }
    }
    return false;
  }
}

if (!customElements.get("redirection-popup")) {
  customElements.define("redirection-popup", RedirectionPopup);
}
